var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReceipt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#FEFEFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 16H24C18 16 16 19.58 16 24V26V54C16 55.66 17.88 56.6 19.2 55.6L22.62 53.04C23.42 52.44 24.54 52.52 25.26 53.24L28.58 56.58C29.36 57.36 30.64 57.36 31.42 56.58L34.78 53.22C35.48 52.52 36.6 52.44 37.38 53.04L40.8 55.6C42.12 56.58 44 55.64 44 54V20C44 17.8 45.8 16 48 16H26ZM34.5 39.5H25.5C24.68 39.5 24 38.82 24 38C24 37.18 24.68 36.5 25.5 36.5H34.5C35.32 36.5 36 37.18 36 38C36 38.82 35.32 39.5 34.5 39.5ZM36 31.5H24C23.18 31.5 22.5 30.82 22.5 30C22.5 29.18 23.18 28.5 24 28.5H36C36.82 28.5 37.5 29.18 37.5 30C37.5 30.82 36.82 31.5 36 31.5Z",
    fill: "#ED6E5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.02 16V19C49.34 19 50.6 19.54 51.52 20.44C52.48 21.42 53 22.68 53 24V28.84C53 30.32 52.34 31 50.84 31H47V20.02C47 19.46 47.46 19 48.02 19V16ZM48.02 16C45.8 16 44 17.8 44 20.02V34H50.84C54 34 56 32 56 28.84V24C56 21.8 55.1 19.8 53.66 18.34C52.2 16.9 50.22 16.02 48.02 16C48.04 16 48.02 16 48.02 16Z",
    fill: "#ED6E5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceipt);
export default __webpack_public_path__ + "static/media/receipt.3f79398199fa08b2f210cdc46f3a0a8f.svg";
export { ForwardRef as ReactComponent };